import { api } from './client'

export interface SystemSetting {
  key: string
  value: string | null
  updatedAt: string
}

export interface AgentProfile {
  id: number
  userId: number
  commissionPercentage: number | null
  bio: string | null
}

export function fetchSettings(): Promise<SystemSetting[]> {
  return api('/api/settings')
}

/**
 * Upserts a single system setting (`PUT /api/settings/{key}`, Admin-gated).
 * `Group`/`Description`/`IsAutoload` are intentionally omitted — the backend
 * only consults them when creating a brand-new key (`SystemSetting.Create`);
 * every save from this page only ever needs `Value` (`SystemSetting.UpdateValue`
 * ignores them too, so it's harmless either way whether the key already exists).
 *
 * `crm.settings.value` used to be a `jsonb` column, which meant a bare,
 * human-typed value like `Acme Srl` was not itself valid JSON and the database
 * rejected it outright (`500 invalid input syntax for type json` on
 * essentially every free-text field in this form). `TASK-0220` fixed this for
 * real at the schema level (`crm.settings.value` is now `text` — see
 * `SettingsDbContext.cs`/`FixSettingsValueColumnType` migration), so
 * `SystemSetting.Value` (`string?`) now round-trips as plain text with no JSON
 * envelope required. `value` is sent as-is; the request body itself is still
 * `JSON.stringify`'d as usual for any `PUT`, that part is unrelated to the
 * jsonb workaround this replaces.
 */
export function upsertSetting(key: string, value: string): Promise<void> {
  return api(`/api/settings/${encodeURIComponent(key)}`, {
    method: 'PUT',
    body: JSON.stringify({ value }),
  })
}

export function fetchAgentProfiles(): Promise<{ total: number; page: number; pageSize: number; items: AgentProfile[] }> {
  return api('/api/agent-profiles')
}
